import { SwitchField } from "components/form/fields";
import { ReleaseStage } from "hooks/tivoApps";

import styles from "../TiVoPublicationsList.scss";
import { PublicationStatus } from "./PublicationStatus";

export function PublicationSwitchCell({
  name,
  releaseStage,
  variantReleaseStages,
  applicableReleaseStages,
  publication,
  isTargetValid,
}: {
  name: string;
  releaseStage: ReleaseStage;
  variantReleaseStages: ReleaseStage[];
  applicableReleaseStages: ReleaseStage[];
  publication?: ReleaseStage[];
  isTargetValid: boolean;
}) {
  if (
    !variantReleaseStages.includes(releaseStage) ||
    !applicableReleaseStages.includes(releaseStage) ||
    !isTargetValid
  ) {
    return (
      <div className={styles.notPublishable}>
        <PublicationStatus
          publication={publication}
          releaseStage={releaseStage}
          variantReleaseStages={variantReleaseStages}
          applicableReleaseStages={applicableReleaseStages}
          isTargetValid={isTargetValid}
        />
      </div>
    );
  }

  return <SwitchField name={name} dataTestId={`${releaseStage}-switch`} />;
}
